// extracted by mini-css-extract-plugin
module.exports = {"row":"row--1AVkf"};